import React from "react";
import "./BlogsPage.css";
import allBlogs from "./../../Component/allBlogs/allBlogs";
import Tittle from "../../Component/Tittle/Tittle";

function BlogsPage() {
  const Blogspage = allBlogs.map((blog) => {
    return (
      <div className="blog" key={blog.id}>
        <div className="blog-content">
          <img src={blog.image} alt="" />
          <a href={blog.link} className="blog-link">
            {blog.title}
          </a>
          <div className="date-container"></div>
        </div>
      </div>
    );
  });

  return (
    <div className="BlogsPage">
      <div className="b-title">
        <Tittle title={"Blogs"} span={"Blogs"} />
      </div>
      <div className="blogs-page">{Blogspage}</div>
    </div>
  );
}

export default BlogsPage;
